import BoxLoaderComponent from "@components/Loader/BoxLoaderComponent.vue";
import VimeoComponent from '@components/Vimeo/VimeoComponent.vue';
import { Vue, axios } from '@master';
import ModalComponent from '@components/Modal/ModalComponent.vue';

const faqPage = new Vue({
    el: '#faq_page',
    data: {
        loading: true,
        query: null,
        faqs: [],
        showVimeoModal: false,
    },
    methods: {
        loadFaqs() {
            this.loading = true;
            axios.get('/resources/loadFaqs').then(response => {
                this.faqs = response.data;
                this.loading = false;
            }).catch(error => {
                this.loading = false;
                this.swalError(error.data.message);
            });
        }
    },
    mounted() {
        this.loadFaqs();
    },
    computed: {
        filteredFaqs() {
            return this.faqs.filter(faq => {
                if(this.query == null) {
                    return true;
                }

                let query = this.query.toLowerCase();
                let regex = /(<([^>]+)>)/ig;
                let question = faq.question.replace(regex, '').toLowerCase();
                let answer = faq.answer.replace(regex, '').toLowerCase();

                if(question.includes(query) || answer.includes(query)) {
                    return true;
                }
            })
        }
    },
    components: {
        'box-loader': BoxLoaderComponent,
        'vimeo': VimeoComponent,
        'modal': ModalComponent,
    }
});
